import { render, staticRenderFns } from "./MagazzinoArticoliGestioneLottiMatricoleListModal.vue?vue&type=template&id=b2ddd4ea&scoped=true"
import script from "./MagazzinoArticoliGestioneLottiMatricoleListModal.vue?vue&type=script&lang=js"
export * from "./MagazzinoArticoliGestioneLottiMatricoleListModal.vue?vue&type=script&lang=js"
import style0 from "./MagazzinoArticoliGestioneLottiMatricoleListModal.vue?vue&type=style&index=0&id=b2ddd4ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ddd4ea",
  null
  
)

export default component.exports